import { atom } from 'jotai'
import { Workspace, Step } from '../types/riskWorkspace.types'
import { EMPTY_WORKSPACE, EMPTY_WORKSPACE_STEPS } from '../../Workspaces/workspace.constants'

export const riskWorkspaceAtom = atom<Workspace>(EMPTY_WORKSPACE)

export const riskWorkspaceCurrentStepAtom = atom<Step>('overview')

export const riskWorkspaceStepAtom = atom<Record<Step, boolean>>(EMPTY_WORKSPACE_STEPS)

// Hazard layer just dropped from the selector into the display, whose scenario dialog should auto-open
export const riskWorkspacePendingScenarioLayerAtom = atom<{
  setIndex: number
  groupIndex: number
  layerId: string
} | null>(null)

riskWorkspaceAtom.debugLabel = 'Workspace Form'
riskWorkspacePendingScenarioLayerAtom.debugLabel = 'Workspace Pending Scenario Layer'
riskWorkspaceStepAtom.debugLabel = 'Workspace Steps'
riskWorkspaceCurrentStepAtom.debugLabel = 'Workspace Current Step'
